import type { HTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';

const chipVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors',
  {
    variants: {
      tone: {
        neutral: 'bg-[#F2F4F7] text-[#344054]',
        busca: 'bg-[#EFF8FF] text-[#175CD3]',
        oferta: 'bg-[#ECFDF3] text-[#067647]',
        success: 'bg-[#ECFDF3] text-[#067647]',
        warning: 'bg-[#FFFAEB] text-[#B54708]',
        info: 'bg-[#EFF8FF] text-[#175CD3]',
        outline: 'border border-border bg-background text-foreground',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export type ChipProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof chipVariants> & {
    leadingIcon?: ReactNode;
  };

export const Chip = ({ className, tone, leadingIcon, children, ...props }: ChipProps) => (
  <span className={cn(chipVariants({ tone }), className)} {...props}>
    {leadingIcon}
    {children}
  </span>
);
